export const REACT_APP_OUTLOOK_REDIRECT_TO_BACKEND_URI = process.env.REACT_APP_OUTLOOK_REDIRECT_TO_BACKEND_URI;

export const REACT_APP_RTK_DEVTOOLS_STATE = process.env.REACT_APP_RTK_DEVTOOLS_STATE === "enabled" ? true : false

export const FINANCE_DEPARTMENT_EMAIL = 'finance@jaspercolin.com'

export const PROJECT_REVIEW_EMAIL = "projects@jaspercolin.com"

export const onboardingOrWholeCipEnum = ['onboarding_only', 'CIP', "only_taas", "onboarding_only_without_forms"]

export const cipVersionEnum = ["Quantitative Data Collection","Quantitative + Qualitative + Desk Research"]
export const PROJECT_INFO_POLLING_INTERVAL = 60000 * 5 // 5 mins

export const CURATED_BASE_API = process.env.REACT_APP_CURATED_BASE_URL;
export const REACT_APP_CIP_URL = process.env.REACT_APP_CIP_URL;


export const CURATED_CREATE_PROPOSAL_PATH = `${CURATED_BASE_API.replace('/api', "")}/admin/content-manager/collectionType/api::kmt-proposal.kmt-proposal/create`
export const CURATED_CREATE_END_CLIENT_PROPOSAL_PATH = `${CURATED_BASE_API.replace('/api', "")}/admin/content-manager/collectionType/api::proposal-end-client.proposal-end-client?page=1&pageSize=10&sort=proposalCode:ASC`
